import { render, staticRenderFns } from "./Duel_Modal_Statistics.vue?vue&type=template&id=55c2203c&scoped=true&"
import script from "./Duel_Modal_Statistics.vue?vue&type=script&lang=js&"
export * from "./Duel_Modal_Statistics.vue?vue&type=script&lang=js&"
import style0 from "./Duel_Modal_Statistics.vue?vue&type=style&index=0&id=55c2203c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c2203c",
  null
  
)

export default component.exports